import { parsePath } from '@common/helpers/url';
import {
  getApiFilters,
  getPagination,
  getSearchParams,
} from '@react/search/helpers';
import { usePrefetch } from '@react/services/api';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';

const useSearch = (baseFilters = {}) => {
  const router = useRouter();
  const location = useMemo(() => parsePath(router.asPath), [router.asPath]);
  const currentFilters = useMemo(
    () => getSearchParams(router.query),
    [router.query]
  );

  const apiFilters = getApiFilters(currentFilters);

  const { requestInfo: requestResult } = usePrefetch('getSearchPage', {
    ...apiFilters,
    ...baseFilters,
  });

  // set the state to avoid blank page during fetch
  const [requestInfo, setRequestInfo] = useState(requestResult);
  useEffect(() => {
    if (requestResult.hasFinished && requestInfo !== requestResult) {
      setRequestInfo(requestResult);
    }
  }, [requestResult]);

  const communities = requestInfo?.normalized;

  const pagination = useMemo(
    () => getPagination(requestInfo.meta, location, currentFilters),
    [requestInfo, location, currentFilters]
  );

  return {
    communities,
    pagination,
    currentFilters,
    location,
  };
};

export default useSearch;
